/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1FeedbackFeedbackidLangsId202,
  PutApiV1FeedbackFeedbackidLangsId400,
  PutApiV1FeedbackFeedbackidLangsId401,
  PutApiV1FeedbackFeedbackidLangsId404,
  PutApiV1FeedbackFeedbackidLangsId409,
  PutApiV1FeedbackFeedbackidLangsId500,
  PutApiV1FeedbackFeedbackidLangsIdMutationRequest,
  PutApiV1FeedbackFeedbackidLangsIdMutationResponse,
  PutApiV1FeedbackFeedbackidLangsIdPathParams,
} from "../../types/feedbackIdiomasController/PutApiV1FeedbackFeedbackidLangsId.ts";
import { feedbackLangViewModelSchema } from "../feedbackLangViewModelSchema.ts";
import { updateFeedbackLangRequestViewModelSchema } from "../updateFeedbackLangRequestViewModelSchema.ts";

export const putApiV1FeedbackFeedbackidLangsIdPathParamsSchema = z.object({
  feedbackId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1FeedbackFeedbackidLangsId202Schema = z.lazy(
  () => feedbackLangViewModelSchema,
) as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1FeedbackFeedbackidLangsId400Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1FeedbackFeedbackidLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1FeedbackFeedbackidLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1FeedbackFeedbackidLangsId409Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1FeedbackFeedbackidLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsId500>;

export const putApiV1FeedbackFeedbackidLangsIdMutationRequestSchema = z.lazy(
  () => updateFeedbackLangRequestViewModelSchema,
) as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsIdMutationRequest>;

export const putApiV1FeedbackFeedbackidLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1FeedbackFeedbackidLangsId202Schema,
) as unknown as ToZod<PutApiV1FeedbackFeedbackidLangsIdMutationResponse>;
